import './ComparisonList.css';const comparisonList = "_comparisonList_jzyfd_1";
const comparisonList__body = "_comparisonList__body_jzyfd_52";
const comparisonList__item = "_comparisonList__item_jzyfd_65";
const comparisonList__track = "_comparisonList__track_jzyfd_114";
const styles = {
  comparisonList,
  "comparisonList--sticky": "_comparisonList--sticky_jzyfd_35",
  comparisonList__body,
  comparisonList__item,
  comparisonList__track
};
export {
  comparisonList,
  comparisonList__body,
  comparisonList__item,
  comparisonList__track,
  styles as default
};
